import React from 'react';
import emailjs from 'emailjs-com';
import { Link } from '@reach/router';
import Footer from '../components/footer';


export default function() {

  function sendEmail(e) {

    const success = document.getElementById("success");
    const button = document.getElementById("buttonsent");
    const failed = document.getElementById("failed");
    e.preventDefault();

    emailjs.sendForm('gmail', 'template_csfdEZiA', e.target, 'user_zu7p2b3lDibMCDutH5hif')
      .then((result) => {
          console.log(result.text);
          success.classList.add('show');
          button.classList.add('show');
          failed.classList.remove('show');
      }, (error) => {
          console.log(error.text);
          failed.classList.add('show');
      });
  }

  return (
    <div>
    <section className='jumbotron breadcumb' style={{backgroundImage: `url(${'./img/witaly_grpup_header.jpg'})`}}>
        <div className='mainbreadcumb'>
          <div className='container-fluid'>
            <div className='row m-10-hor'>
              <div className='col-md-6'>
                <h1>Contact</h1>
              </div>
              <div className='col-md-6'>
                <div className='list'>
                  <Link className='link' to="/home">Home</Link>
                  <span className='dash'>/</span>
                  <span>Contact</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className='container-fluid black_more'>
        <div className='row m-10-hor'>
          <div className='col-md-6'>
           <div className="text-side">
             <h2>Let's Work Together</h2>
              <p>
                Have a project in mind? We'd love to hear about it. Fill in the
                form and one of our team will be in touch within 24 hours.
              </p>

              <div className='address'>
                <div className='heading'>Our Office</div>
                <div className='list'>
                  <i className="fa fa-map-marker"></i>
                  Vision Plaza, 3rd Floor, Suite 13<br/>
                  Mombasa Road, Nairobi, Kenya
                </div>
                <div className='list'>
                  <i className="fa fa-envelope-o"></i>
                  <a href='mailto:info@witaly-group.com' target='_blank' rel='noopener noreferrer'>
                    info@witaly-group.com
                  </a>
                </div>
                <div className='list'>
                  <i className="fa fa-phone"></i>
                  +254 726 942 083
                </div>
                <div className='list'>
                  <i className="fa fa-phone"></i>
                  +254 741 932 254
                </div>
                <div className='list'>
                  <i className="fa fa-clock-o"></i>
                  Mon – Fri &nbsp;|&nbsp; 8:00 AM – 6:00 PM EAT
                </div>
              </div>
           </div>
          </div>
          <div className='col-md-6'>
            <div className="form-side">
              <form className="formcontact" onSubmit={sendEmail}>
                <label>Full Name</label>
                <input type="text" name="user_name" placeholder="Your full name" required />
                <label>Email Address</label>
                <input type="email" name="user_email" placeholder="your@email.com" required />
                <label>Phone Number</label>
                <input type="tel" name="user_phone" placeholder="+254 700 000 000" />
                <label>Message</label>
                <textarea name="message" rows="5" placeholder="Tell us about your project..." required />
                <div id='success' className='hide'>
                  Thank you! Your message has been sent. We'll be in touch shortly.
                </div>
                <div id='failed' className='hide'>
                  Something went wrong. Please try again or email us directly.
                </div>
                <button type="submit" id='buttonsent'>
                  <span className="shine"></span>
                  <span>Send Message</span>
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
